function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "v02",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Edit-Units_Financials_DefaulT_v02",
  transform: "translate(-1176.000000, -156.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1177,165 L1186,165 L1186,163 L1177,163 L1177,165 Z M1177,166 L1177,167.633333 C1177,167.835838 1177.17673,168 1177.39474,168 L1191.60526,168 C1191.82327,168 1192,167.835838 1192,167.633333 L1192,157.366667 C1192,157.164162 1191.82327,157 1191.60526,157 L1190,157 L1190,159 L1192,159 L1192,160 L1190,160 L1190,162 L1192,162 L1192,163 L1190,163 L1190,165 L1192,165 L1192,166 L1190,166 L1190,168 L1189,168 L1189,166 L1187,166 L1187,168 L1186,168 L1186,166 L1177,166 Z M1189,165 L1189,163 L1187,163 L1187,165 L1189,165 Z M1177,162 L1186,162 L1186,160 L1177,160 L1177,162 Z M1189,162 L1189,160 L1187,160 L1187,162 L1189,162 Z M1177,159 L1186,159 L1186,157 L1177.39474,157 C1177.17673,157 1177,157.164162 1177,157.366667 L1177,159 Z M1189,159 L1189,157 L1187,157 L1187,159 L1189,159 Z M1177.21429,156 L1191.78571,156 C1192.45635,156 1193,156.513556 1193,157.147059 L1193,167.852941 C1193,168.486444 1192.45635,169 1191.78571,169 L1177.21429,169 C1176.54365,169 1176,168.486444 1176,167.852941 L1176,157.147059 C1176,156.513556 1176.54365,156 1177.21429,156 Z",
  id: "icon_table-cell_default"
})));

function SvgIconTableCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "13px",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "83A31F15-F1C8-44AA-AEC5-BB382BC194FC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableCell);
export default __webpack_public_path__ + "static/media/icon_table_cell.24931443.svg";
export { ForwardRef as ReactComponent };